import React from 'react';

// Find icons on this page
// https://fontawesome.com/v4.7.0/icons/

const fontAwesomeIcon = (name, className) => (
  <i className={`fa fa-${name} ${className || ''}`} aria-hidden="true" />
);

export default {
  CrossIcon: ({ className }) => fontAwesomeIcon('times', className),
  ViewMoreIcon: ({ className }) => fontAwesomeIcon('plus', className),
  ExpandIcon: ({ className }) => fontAwesomeIcon('expand', className),
  CollapseIcon: ({ className }) => fontAwesomeIcon('compress', className),
  DownloadIcon: ({ className }) => fontAwesomeIcon('download', className),
  EyeIcon: ({ className }) => fontAwesomeIcon('eye', className),
  EyeSlashIcon: ({ className }) => fontAwesomeIcon('eye-slash', className),
  BackIcon: ({ className }) => fontAwesomeIcon('chevron-left', className),
  ThumbtackIcon: ({ className }) => fontAwesomeIcon('thumb-tack', className),
  SearchIcon: ({ className }) => fontAwesomeIcon('search', className),
  SaveIcon: ({ className }) => fontAwesomeIcon('save', className),
  Custom: ({ name, className }) => fontAwesomeIcon(name, className),
  // eslint-disable-next-line no-unused-vars
  Clipboard: ({ name, className }) => fontAwesomeIcon('clipboard', className),
  // eslint-disable-next-line no-unused-vars
  Setting: ({ name, className }) => fontAwesomeIcon('cog', className),
};
